import { Header, DeviceError as DeviceErrorComponent } from "components"
export const DeviceError = () => {
 return (
  <div>
   <div className="z-10 relative">
    <Header />
   </div>
   <DeviceErrorComponent />
  </div>
 )
}
